export default __webpack_public_path__ + "static/media/marutisuzuki.ed691db7.png";